import { updateTOC } from "./counterSlice.js";

//import events from external files here.
import $ from "jquery";
import { rxhtmltag4jQuery } from "./rxhtmltag.js";
import { getUrlObj, parseMapToDOM } from "../../utils/index.js";
import updateActiveTopicHrefSearchPath from "./updateActiveTopicHrefSearchPath.js";

rxhtmltag4jQuery();

export function UpdateURL(selectedHref, dartSelectors, tag = "", fromClick = false) {
  let XRefPath = selectedHref;
  let urlObj = getUrlObj();
  if (!selectedHref?.includes("#") && urlObj.hash !== "" && !urlObj.search.includes("sectionId")) {
    XRefPath += urlObj.hash;
  } else if (tag !== "" && tag !== "H2") {
    XRefPath += "#" + tag;
  }

  if (selectedHref?.includes("../../")) {
    selectedHref = selectedHref.split("../../")[1];
  }
  selectedHref = selectedHref?.replace(/\.\.\//g, "");

  if (selectedHref?.includes("#")) {
    selectedHref = selectedHref.split("#")[0];
  }

  const domMap = parseMapToDOM(dartSelectors.map);
  const container_tg_toc_id = document.getElementById("tg_toc_id");
  const tocIdElm = container_tg_toc_id?.querySelector(`[href*="${selectedHref}"]`);
  let tocPathJS = tocIdElm?.getAttribute("tocpath");
  let mpsPathJS = tocIdElm?.getAttribute("mpspath");
  if (mpsPathJS === undefined && selectedHref) {
    let section_id = selectedHref.split("-").slice(0, -1).join("-");
    const sectionToc = domMap?.querySelector('[href*="' + section_id + '"]');
    mpsPathJS = sectionToc?.getAttribute("mpspath");
  }
  if (mpsPathJS !== undefined) {
    mpsPathJS = mpsPathJS.replace(")", "").replace("(", "");
  }

  const selectedTopicEl = container_tg_toc_id?.querySelector(`[href*="${selectedHref}"]`);

  let selectedTopicJS = selectedTopicEl?.getAttribute("href");

  let urlConfig = localStorage.getItem("darturl") === "1" ? tocPathJS : mpsPathJS;

  let currentHash = urlObj.href.replace(urlObj.protocol + "//" + urlObj.host, "");
  // remove activeElm after enhacedcounter check
  const activeElm = domMap.getElementsByClassName("active");
  console.log("activeElm", activeElm);
  // ready to navigate
  // const redirectUrl =
  processUrlUpdate(
    currentHash,
    urlConfig,
    dartSelectors,
    mpsPathJS,
    fromClick,
    selectedHref,
    window,
  );

  // Select all <xref> and <term> elements in the parsed DOM
  const elements = domMap.querySelectorAll("xref, term");

  // Loop and remove the "active" class from each
  elements.forEach((el) => {
    el.classList.remove("active");
  });
  setTimeout(() => {
    dartSelectors.dispatch(
      updateTOC({
        selectedTopic: selectedTopicJS,
        XRefPath,
        dartSelectors,
        tag,
      }),
    );
  });
}

function processUrlUpdate(
  currentHash,
  urlConfig,
  dartSelectors,
  mpsPath,
  fromClick,
  selectedHref,
  window,
) {
  if (!currentHash || !urlConfig) {
    return;
  }
  if (currentHash.replace(/\//g, "") !== urlConfig.replace(/\//g, "")) {
    if (
      urlConfig ===
      "/viewTopic?etgAccess=true&guidelinePage=Antibiotic&topicfile=acute-gastroenteritis&guidelinename=Antibiotic&sectionId=toc_d1e1473#toc_d1e1438"
    ) {
      urlConfig =
        "/viewTopic?etgAccess=true&guidelinePage=Antibiotic&topicfile=acute-gastroenteritis&guidelinename=Antibiotic&sectionId=toc_d1e1455#toc_d1e1438";
    }

    if (window.location.href.includes("topicTeaser")) {
      urlConfig = urlConfig.replace("viewTopic", "topicTeaser");

      setTimeout(() => {
        if (
          (parseInt($("topicref.active:last").attr("level")) > 2 && $(".username").text() !== "") ||
          (parseInt($("topicref.active:last").attr("level")) === 1 &&
            $("topicref.active:last").text().includes("calculator"))
        ) {
          urlConfig = urlConfig.replace("topicTeaser", "viewTopic");
          window.location = urlConfig;
        } else {
          $(".tablesfigurestables").on("click", function () {
            window.location.href = $(this).attr("mpspath");
          });

          $(".tablesfiguresfigures").on("click", function () {
            window.location.href = $(this).attr("mpspath");
          });
        }
      }, 500);
    }

    if (
      window.location.href.toLowerCase().includes("calculator") &&
      window.location.href.includes("viewTopic")
    ) {
      setTimeout(() => {
        let calcURL = $('[classname="bodyContentDiv"] xref').attr("href");
        window.location = calcURL;
      }, 1000);
    }
    if (fromClick && !urlConfig) {
      const currentURL = window.location.href;
      const url = new URL(currentURL);
      const queryParameters = url.searchParams;
      const modifiedHref = selectedHref.replace(/^(\.\.\/)+/, "");
      const splitHref = modifiedHref.split("/");
      if (splitHref.length === 3) {
        const guidelinePage = splitHref[0];
        const topicFile = splitHref[1];
        const sectionId = splitHref[2].replace(/\.dita$/, "");
        queryParameters.set("guidelinePage", guidelinePage);
        queryParameters.set("topicfile", topicFile);
        queryParameters.set("sectionId", sectionId);
        const updatedUrl = `${url.pathname}?${queryParameters.toString()}#${sectionId}`;

        dartSelectors.navigate(updatedUrl, {
          replace: dartSelectors.isModernView && !fromClick,
          state: dartSelectors.location.state,
        });
      }
    } else {
      if (urlConfig !== currentHash) {
        dartSelectors.navigate(urlConfig, {
          replace: dartSelectors.isModernView && !fromClick,
          state: dartSelectors.location.state,
        });
      }
    }
  }
}
//Move to separate file if there are a lot of functions.
//e.g. call this ditaTopicref.js for example and import above.
export function HandleTOCClick(dartSelectors, isEnhancedBrowserHistoryButton) {
  const handleClick = (elem) => {
    const selectedHref = elem?.attr("href");
    const mpsPathJS = elem?.attr("mpspath");
    const header = elem.find("concept > ditatitle").first().text().trim();

    if (!selectedHref) return;

    // Route special cases
    switch (selectedHref) {
      case "Antibiotic/c_creatinine_clearance_calculator_for_adults.dita":
        dartSelectors.navigate("/calculator/ccbwcalc");
        return;
      case "Antibiotic/c_glomerular_filtration_rate_GFR_calculator_for_children.dita":
        dartSelectors.navigate("/calculator/gfrcalc");
        return;
      case "Antibiotic/Calculators/Gentamicin_initial_dose_calculator.dita":
        dartSelectors.navigate("/calculator/Gentamicin");
        return;
      case "Antibiotic/Calculators/Tobramycin_initial_dose_calculator.dita":
        dartSelectors.navigate("/calculator/Tobramycin");
        return;
      case "Antibiotic/Calculators/Amikacin_initial_dose_calculator.dita":
        dartSelectors.navigate("/calculator/Amikacin");
        return;
      default:
    }

    // Maintain enhanced history stack
    updateActiveTopicHrefSearchPath({
      dispatch: dartSelectors.dispatch,
      activeTopicHRefSearchPath: dartSelectors.activeTopicHRefSearchPath,
      mpsPathJS,
      selectedHref,
      header,
      isEnhancedBrowserHistoryButton,
    });

    // Navigate
    UpdateURL(selectedHref, dartSelectors, "", true);
  };

  $("concept>ditatitle, topic>ditatitle").on("click", function () {
    const elem = $(this).closest("topicref");
    handleClick(elem);
  });

  $("bookmap>ditatitle").on("click", function () {
    const elem = $(this).closest("bookmap").find("chapter:eq(0)");
    handleClick(elem);
  });
}
